import {Directive, Input, OnInit, Optional, TemplateRef} from '@angular/core';
import {FieldCtx, MxFieldCustomizerService} from '../../services/mx-field-customizer.service';


export enum FieldPlacement {replace = 'replace', before = 'before', after = 'after'}

@Directive({
    selector: '[mxFormField]',
    standalone: false,
})
export class MxFormFieldDirective implements OnInit {

    /** field name */
    private _formField: string;
    /** field placement */
    private _formFieldPlacement: FieldPlacement;

    @Input()
    set mxFormField(value: string) {
        this._formField = value;
    }

    @Input()
    set mxFormFieldPlacement(value: FieldPlacement) {
        this._formFieldPlacement = value;

    }


    private setTemplateInContainer(): void {
        if (!this._customizerService) {
            throw new Error('You have to provide BoFieldCustomizerService');
        }
        switch (this._formFieldPlacement) {
            case FieldPlacement.replace :
                this._customizerService.replace(this._formField, this._template);
                break;
            case FieldPlacement.before :
                this._customizerService.addBefore(this._formField, this._template);
                break;
            case FieldPlacement.after :
                this._customizerService.addAfter(this._formField, this._template);
                break;
            default:
                throw new Error(`mxFormField unknown placement ${this._formFieldPlacement}`);
        }
    }

    constructor(private _template: TemplateRef<FieldCtx>, @Optional() private _customizerService: MxFieldCustomizerService) {
    }

    ngOnInit(): void {
        this.setTemplateInContainer();
    }

}
